import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaWallet } from 'react-icons/fa'; // Import wallet icon from react-icons
import './Header.css';
import Assets from '../../Assets/Assets';
import apiClient from '../../axios';

function Header() {
    const [userData, setUserData] = useState({ userName: 'Guest', email: '', phone: '' });
    const [error, setError] = useState(null);
    const Token = sessionStorage.getItem('Token');
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch user details with the configured Axios instance
        apiClient.get('/getusers/details')
            .then((response) => {
                const userDetails = response?.data?.data?.users_details[0];
                if (userDetails) {
                    setUserData({
                        userName: userDetails.user_name || 'Guest',
                        email: userDetails.email || '',
                        phone: userDetails.phone || '',
                    });
                }
                sessionStorage.setItem('user_name', userDetails?.user_name);
                sessionStorage.setItem('UIID', userDetails?.u_id);
            })
            .catch((error) => {
                console.error('Error fetching user details:', error);
                setError('Failed to fetch user details.');
            });
    }, []);

    const username = sessionStorage.getItem('user_name');
    const firstLetterUpperCase = username?.charAt(0).toUpperCase();

    return (
        <header className="header">
            <div className="header-content">
                <div className="header-logo">
                    <img src={Assets?.Logo} alt="Logo" className="logo" />
                </div>
                <div className="header-user">
                    {error ? (
                        <span className="user-name error">{error}</span>
                    ) : (
                        <>
                            <span className="user-name">{username}</span>
                            <div className="profile-photo">
                                {firstLetterUpperCase}
                            </div>
                        </>
                    )}
                    {/* Add wallet icon with react-icons */}
                    <div 
                        className="wallet-icon" 
                        onClick={() => navigate('/wallet')} // Navigate to wallet page
                        title="Go to Wallet"
                    >
                        <FaWallet className="wallet-icon-react" /> {/* React Icon */}
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;
